/**
 * Unregisters any service worker registrations that have a script URL containing 'firebase-messaging-sw.js'.
 *
 * @param {Navigator} navigator - The Navigator object, which provides access to the service worker registrations.
 * @returns {Promise<void>} - A Promise that resolves when the unregistration process is complete.
 */
export async function unregisterFCMServiceWorkers(navigator) {
  const registrations = await navigator.serviceWorker.getRegistrations()

  for (let i = 0; i < registrations.length; i++) {
    const registration = registrations[i]
    const splitURL = registration.active.scriptURL.split('/')

    if (splitURL.includes('firebase-messaging-sw.js')) await registration.unregister()
  }
}
